module.exports = __webpack_public_path__ + "static/liva-two-case-study-00b25618d2d2bad3168753b963aa40e2.webp";